export default __webpack_public_path__ + "static/SRUS AP100 - Product Specifications & Technical Data-efa6e6ae50062e99ac917cb2c8fd1a54.pdf";